import {FETCH_MY_COURSE} from "../../actions";

export default (state = [], action) => {
    switch (action.type) {
        case FETCH_MY_COURSE:
            return action.payload;
        default:
            return state;
    }
};